/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_down': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M1.7 83.5L128.2 210 254.7 83.5l-38-38-88.5 88.5-88.5-88.5z"/>'
  }
})
